import React from 'react';
import { connect } from 'react-redux';

import AmazonPayLogo from 'images/amazon-pay.svg';

import css from 'styles/containers/account/amazonPayOrderCare.scss';

export const AmazonPayOrderCare = ({
  amazonPayRemediationURL = 'https://amazon.com',
  amazonPayRemediationMessaging: {
    buttonLabel = 'Update Card',
    showRemediationButton = false,
    remediationMessage = 'Oops, your Amazon Pay order didn’t go through. Update your order payment method by calling customer support (877) 927-2332',
    afterButtonMessage
  } = {}
}) => (
  <div className={css.container}>
    <img src={AmazonPayLogo} width="100" alt="Amazon Pay" />
    <p>{remediationMessage}</p>
    {showRemediationButton && (
      <a href={amazonPayRemediationURL} target="_blank" className={css.amazonPayLink} rel="noopener noreferrer">
        {buttonLabel}
      </a>
    )}
    {!!afterButtonMessage && <p>{afterButtonMessage}</p>}
  </div>
);

const mapStateToProps = state => {
  const { content } = state.account || {};
  const amazonPayRemediationMessaging = content?.['amazon-pay-remediation-message'];

  return {
    amazonPayRemediationMessaging
  };
};

export default connect(mapStateToProps)(AmazonPayOrderCare);
